import currency from 'src/app/utilities/helpers/currency';
import supportedCurrencies, {
    ticketSalesCapCurrencies,
} from 'src/data/constants/supportedCurrencies';

const currencyOptions = currency.currenciesToOptions(supportedCurrencies);
export const ticketSalesCapCurrencyOptions = currency.currenciesToOptions(ticketSalesCapCurrencies);

export default currencyOptions;
